new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#app_list',
  data: {
    menuFilter: false,
    listOpened: false,
    listEx: localStorage.getItem('listOrder') ? localStorage.getItem('listOrder') : localStorage.setItem('listOrder', 0),
    listExMobile: localStorage.getItem('listOrderMobile') ? localStorage.getItem('listOrderMobile') : localStorage.setItem('listOrderMobile', 0)
  },
  methods: {
    filterPrice() {
      //chamadas para o filtro de preço
      function controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
        const [from, to] = getParsed(fromInput, toInput);
        fillSlider(fromInput, toInput, '#dddddd', '#2E2E2E', controlSlider);
        if (from > to) {
          fromSlider.value = to;
          fromInput.value = to;
        } else {
          fromSlider.value = from;
        }
      }

      function controlToInput(toSlider, fromInput, toInput, controlSlider) {
        const [from, to] = getParsed(fromInput, toInput);
        fillSlider(fromInput, toInput, '#dddddd', '#2E2E2E', controlSlider);
        setToggleAccessible(toInput, controlSlider);
        if (from <= to) {
          toSlider.value = to;
          toInput.value = to;
        } else {
          toInput.value = from;
        }
      }

      function controlFromSlider(fromSlider, toSlider, fromInput) {
        const [from, to] = getParsed(fromSlider, toSlider);
        fillSlider(fromSlider, toSlider, '#dddddd', '#2E2E2E', toSlider);
        if (from > to) {
          fromSlider.value = to;
          fromInput.value = to;
        } else {
          fromInput.value = from;
        }
      }

      function controlToSlider(fromSlider, toSlider, toInput) {
        const [from, to] = getParsed(fromSlider, toSlider);
        fillSlider(fromSlider, toSlider, '#dddddd', '#2E2E2E', toSlider);
        setToggleAccessible(toSlider, toSlider);
        if (from <= to) {
          toSlider.value = to;
          toInput.value = to;
        } else {
          toInput.value = from;
          toSlider.value = from;
        }
      }

      function getParsed(currentFrom, currentTo) {
        const from = parseInt(currentFrom.value, 10);
        const to = parseInt(currentTo.value, 10);
        return [from, to];
      }

      function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
        const rangeDistance = to.max - to.min;
        const fromPosition = from.value - to.min;
        const toPosition = to.value - to.min;
        controlSlider.style.background = `linear-gradient(
      to right,
      ${sliderColor} 0%,
      ${sliderColor} ${(fromPosition) / (rangeDistance) * 100}%,
      ${rangeColor} ${((fromPosition) / (rangeDistance)) * 100}%,
      ${rangeColor} ${(toPosition) / (rangeDistance) * 100}%, 
      ${sliderColor} ${(toPosition) / (rangeDistance) * 100}%, 
      ${sliderColor} 100%)`;
      }

      function setToggleAccessible(currentTarget, toSlider) {
        if (Number(currentTarget.value) <= 0) {
          toSlider.style.zIndex = 2;
        } else {
          toSlider.style.zIndex = 0;
        }
      }

      document.querySelectorAll('.product-filter--price').forEach((priceFilter) => {
        const fromSlider = priceFilter.querySelector('.price-slider--from');
        const toSlider = priceFilter.querySelector('.price-slider--to');
        const fromInput = priceFilter.querySelector('.price-input--from');
        const toInput = priceFilter.querySelector('.price-input--to');

        if (!fromSlider || !toSlider || !fromInput || !toInput) return;

        const params = new URLSearchParams(window.location.search);
        const selectedFrom = params.get('lp');
        const selectedTo = params.get('hp');

        if (selectedFrom !== null && selectedTo !== null) {
          fromInput.value = selectedFrom;
          toInput.value = selectedTo;
          fromSlider.value = selectedFrom;
          toSlider.value = selectedTo;
        }

        fillSlider(fromSlider, toSlider, '#dddddd', '#2E2E2E', toSlider);
        setToggleAccessible(toSlider, toSlider);

        fromSlider.oninput = () => controlFromSlider(fromSlider, toSlider, fromInput);
        toSlider.oninput = () => controlToSlider(fromSlider, toSlider, toInput);
        fromInput.oninput = () => controlFromInput(fromSlider, fromInput, toInput, toSlider);
        toInput.oninput = () => controlToInput(toSlider, fromInput, toInput, toSlider);

        const applyPrice = () => {
          const currentParams = new URLSearchParams(window.location.search);
          const from = parseInt(fromInput.value, 10);
          const to = parseInt(toInput.value, 10);

          if (Number.isNaN(from) || Number.isNaN(to)) return;

          currentParams.set('lp', Math.min(from, to));
          currentParams.set('hp', Math.max(from, to));
          window.location.href = `${window.location.pathname}?${currentParams.toString()}${window.location.hash}`;
        };

        [fromSlider, toSlider].forEach((slider) => {
          slider.addEventListener('mouseup', applyPrice);
          slider.addEventListener('touchend', applyPrice);
          slider.addEventListener('keyup', (event) => {
            if (['ArrowLeft', 'ArrowRight', 'Home', 'End', 'PageUp', 'PageDown'].includes(event.key)) {
              applyPrice();
            }
          });
        });

        fromInput.addEventListener('change', applyPrice);
        toInput.addEventListener('change', applyPrice);
      });
    },
    changeList(list) {
      this.listEx = list;
      localStorage.setItem('listOrder', list);
    },

    changeListMobile(list) {
      this.listExMobile = list;
      this.listOpened = false;
      localStorage.setItem('listOrderMobile', list);
    }
  },
  mounted() {
    this.filterPrice();
  },
});

document.addEventListener('DOMContentLoaded', () => {

  const appList = document.querySelector('#app_list');
  const filterDrawer = document.querySelector('.product-list__filters');
  const filterOverlay = document.querySelector('.product-list__overlay');
  const filterOpeners = document.querySelectorAll('.product-list__section--header-filter');
  const selectedFilter = filterDrawer && filterDrawer.querySelector('[data-filter-selected-count]');

  if (filterDrawer) {
    filterDrawer.setAttribute('role', 'dialog');
    filterDrawer.setAttribute('aria-modal', 'true');
    filterDrawer.setAttribute('aria-label', 'Filtros');
  }

  const closeFilterDrawer = () => {
    if (appList && appList.__vue__) {
      appList.__vue__.menuFilter = false;
    }
  };

  if (filterOverlay) {
    filterOverlay.addEventListener('click', closeFilterDrawer);
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeFilterDrawer();
    }
  });

  if (selectedFilter) {
    const legacyCount = Number(selectedFilter.dataset.filterSelectedCount) || 0;
    const queryCount = ['q_legacy', 'cat_legacy', 'lp_legacy'].filter((id) => {
      const input = document.getElementById(id);
      return input && input.value;
    }).length;
    const activeCount = legacyCount + queryCount;

    if (activeCount) {
      filterOpeners.forEach((opener) => {
        const badge = document.createElement('span');
        badge.className = 'product-list__filter-count';
        badge.textContent = activeCount;
        badge.setAttribute('aria-label', `${activeCount} filtros ativos`);
        opener.appendChild(badge);
      });
    }
  }

  if (appList && filterDrawer && window.MutationObserver) {
    const observer = new MutationObserver(() => {
      document.body.classList.toggle('filter-drawer-open', Boolean(filterDrawer && filterDrawer.classList.contains('active')));
    });
    observer.observe(filterDrawer, { attributes: true, attributeFilter: ['class'] });
  }

  const filterSize = document.querySelector(".product-list__filters .product-filter--filters .product-filter__item--size .product-filter__sub-menu");
    if(filterSize) {
        const cloneFilterSize = filterSize.cloneNode(true);
        const elementDest = document.querySelector("#buy-sizes");
        if(cloneFilterSize && elementDest) {
            elementDest.append(cloneFilterSize);
        }
    } else {
        const buySizes = document.querySelector('#buy-sizes');
        if (buySizes) buySizes.classList.add('no-size');
    }

  const thirdVitrine = document.querySelector('#product_list3');
  if (thirdVitrine) {
    $('#product_list3').slick({
      arrows: true,
      dots: false,
      infinite: false,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 700,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToScroll: 3,
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToScroll: 4,
            slidesToShow: 4,
          }
        }
      ]
    });

    $('#product_list3').on('afterChange', function (event, slick, currentSlide, nextSlide) {
      Blazy({
        selector: '.lazy-img',
        successClass: 'loaded-img',
        success: function (element) {
          setTimeout(function () {
            var parent = element.previousSibling;
            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
          }, 200);
        }
      });
    });
  }
})
